import React from 'react';
import {Icon, Popconfirm} from "antd";
import {injectIntl} from "react-intl";

class SAPopconfirm extends React.Component {
  
  render() {
    const {intl: {formatMessage}, title, action, ...attributes} = this.props;

    return (
      <Popconfirm title={action ? formatMessage({id: `popup.${action}.confirmation`}) : title}
                  okText={formatMessage({id: 'yes'})}
                  cancelText={formatMessage({id: 'no'})}
                  icon={<Icon type="question-circle-o" style={{color: 'red'}}/>}
                  {...attributes}>
        {this.props.children}
      </Popconfirm>
    )
  }
}

export default injectIntl(SAPopconfirm);



// WEBPACK FOOTER //
// ./src/components/common/confirmation/SAPopconfirm.js